import script from "./AutogenCaptionProfileSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./AutogenCaptionProfileSelector.vue?vue&type=script&setup=true&lang=js"

import "./AutogenCaptionProfileSelector.vue?vue&type=style&index=0&id=12c79c63&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12c79c63"]])

export default __exports__